import HttpCliente from "../HttpCliente";

export const getBandejaNormativas = (pageNumber, pageSize, filtros = {}, token) => {
  return new Promise((resolve, reject) => {
    const queryParams = new URLSearchParams({
      pageNumber: pageNumber,
      pageSize: pageSize,
      ...(filtros.nombre && { nombre: filtros.nombre }),
      ...(filtros.regulador && { regulador: filtros.regulador }),
      ...(filtros.tipoDocumento && { tipoDocumento: filtros.tipoDocumento }),
      ...(filtros.rubro && { rubro: filtros.rubro }),  
      ...(filtros.pais && { pais: filtros.pais }), 
    });

    HttpCliente.get(`/Normativa/ObtenerBandeja?${queryParams}`, {
      headers: {
        ...(token && { "Authorization": `Bearer ${token}` }),
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error al obtener bandeja:", error);
      reject(error);
    });
  });
};

export const getReguladores = (token, paisId = null) => {
  return new Promise((resolve, reject) => {
    const url = paisId
      ? `/Normativa/ObtenerReguladores?paisId=${paisId}`
      : '/Normativa/ObtenerReguladores';

    HttpCliente.get(url, {
      headers: {
        ...(token && { "Authorization": `Bearer ${token}` }),
        'accept': 'application/json'
      }
    }).then(response => {
      resolve(response.data.items || []);
    }).catch(error => {
      console.error("Error al obtener reguladores:", error);
      reject(error);
    });
  });
};

export const getTiposDocumentoBandeja = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get('/Normativa/ObtenerTiposDocumento', {
      headers: {
        ...(token && { "Authorization": `Bearer ${token}` }),
        'accept': 'application/json'
      }
    }).then(response => {
      resolve(response.data.items || []);
    }).catch(error => {
      console.error("Error al obtener tipos de documento:", error);
      reject(error);
    });
  });
};

export const getRubrosBandeja = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get('/Normativa/ObtenerRubros', {
      headers: {
        ...(token && { "Authorization": `Bearer ${token}` }),
        'accept': 'application/json'
      }
    }).then(response => {
      resolve(response.data.items || []);
    }).catch(error => {
      console.error("Error al obtener rubros:", error);
      reject(error);
    });
  });
};

export const getPaisesBandeja = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get('/Normativa/ObtenerPaises', {
      headers: {
        ...(token && { "Authorization": `Bearer ${token}` }),
        'accept': 'application/json'
      }
    }).then(response => {
      resolve(response.data.items || []);
    }).catch(error => {
      console.error("Error al obtener paises:", error);
      reject(error);
    });
  });
};

export const getNormativaBandejaById = (id, token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Normativa/ObtenerBandeja/${id}`, {
      headers: {
        ...(token && { "Authorization": `Bearer ${token}` }),
        'accept': 'application/json'
      }
    }).then(response => {
      resolve(response.data.item);
    }).catch(error => {
      console.error("Error al obtener normativa por id:", error);
      reject(error);
    });
  });
};